// 导入封装好的 axios 实例
import request from '@/utils/request'


//列表接口
export function certifyList(data) {
    return request({
        url: '/program/certify/page',
        method: 'post',
        data
    })
}


export function postCertify(data) {
    return request({
        url: '/program/certify',
        method: 'post',
        data
    })
}

export function putCertify(data) {
    return request({
        url: '/program/certify',
        method: 'put',
        data
    })
}

export function enableCertify(id) {
    return request({
        url: `/program/certify/enabled/${id}`,
        method: 'get',
    })
}

export function deleteCertify(id){
    return request({
        url: `/program/certify/${id}`,
        method: 'delete',
    })
}
